import ButtonComponent from "@components/Theme/Button/Button"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {AdvancedSideAssetModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./TitleSection.module.scss"

type Props = {
	pageData: AdvancedSideAssetModuleType
}

const TitleSection = (props: Props) => {
	return (
		<div className={styles.headerContainer}>
			<Typography
				content={props.pageData.sectionTitle}
				variant={Variant.SectionTitle}
			/>
			{props.pageData.sectionBottomButton && (
				<ButtonComponent
					buttonType={"secondary"}
					className={styles.Button}
					link={props.pageData.sectionBottomButtonLink}
					asLink
				>
					{props.pageData.sectionBottomButton}
				</ButtonComponent>
			)}
		</div>
	)
}

export default TitleSection
